import { DEFAULT_LANGUAGE } from '@/helpers';

import { RouteInitialize } from './createRoute';

const getPath = (RouteInstance: RouteInitialize, lang: string) => {
  const localePrefix = lang === DEFAULT_LANGUAGE ? '' : `/${lang}`;

  if (RouteInstance.path) {
    return `${localePrefix}/${RouteInstance.path}`;
  } else {
    return localePrefix || '/';
  }
};

export default getPath;
